// import vantEnUS from 'vant/lib/locale/lang/en-US';
import constant from '../../constants/lang/en';
import newLang from '../newLang/en';
/* eslint-disable max-len */

export default {
  // ...vantEnUS,
  cfmoto: {
    ...(newLang.cfmoto || {}),
    constant,
    api: {
      http: {
        401: 'Please login first',
        404: 'No data',
        500: 'System is busy, please try again later',
        504: 'Request timed out',
        ERR_NETWORK: 'Network exception',
        ERR_NETWORK_UPLOAD: 'Upload failed, please try another network',
      },
    },
    title: 'Intemet International',
    navbar: {
      dropdown: {
        updatePassword: 'update password',
        switchLanguage: 'switch language',
        logout: 'log out',
      },
    },
    router: {
      title: {
        'binding-agreement': '绑车协议',
        introduce: '介绍',
        lamp: 'Indicator Light',
        download: 'CFMOTO RIDE APP Download',
        orderConfirm: 'Order Confirmation',
        ebook: 'ebook',
        list: 'ebook',
        pdf: 'PDF',
        feedback: 'Records',
        'feedback-create': 'Feedback',
        'feedback-supplement': 'Additional Feedback',
        'feedback-detail': 'Feedback details',
        'feedback-result': 'Feedback',
        guide: 'Help Center',
        'guide-restScreen': 'Setup instructions',
        'guide-overview': 'Overview',
        'guide-account': 'About Account',
        'guide-vehicle': 'About the vehicle',
        'guide-meterSetting': 'Set up the dashboard',
        'guide-vehicleSetting': 'Set up the vehicle ',
        'guide-findNavigation': 'Find the vehicle',
        'guide-vehicleNnavigation': 'Navigation',
        'guide-cyclingRecord': 'About Ride History',
        'guide-vehicleExperience': 'Inspection',
        'guide-useSetting': 'APP settings',
        'guide-notice': 'View and set message notification',
        'guide-about': 'About APP',
        help: 'Help & feedback',
        'help-detail': 'Question details',
        'myCar-unbinding': 'Apply Unbinding',
        'myCar-unbinding-result': 'Apply Unbinding',
      },
    },
    form: {
      cancel: 'Cancel',
      confirm: 'Confirm',
      submit: 'Submit',
      search: 'Search',
      language: {
        languageCode: {
          label: 'select language',
          placeholder: 'please select language',
        },
      },
    },
    rules: {
      language: {
        languageCode: {
          required: 'please select language',
        },
      },
    },
    dialog: {
      language: 'select language',
    },
    binding: {
      title: `Disclaimer`,
      text1: '1.	Telematics Services',
      text2:
        'CFMOTO Powersports, Inc.(hereinafter referred to as “CFMOTO”) provides vehicle telematics services to the customer who bought the CFMOTO vehicle(hereinafter referred to as “Customer”). For these services, CFMOTO uses data recorded by the Vehicle about the Vehicle and its driving behavior in the relevant period of time. In detail, this concerns the following data:',
      text3: 'User Driving Behavior Data: including acceleration, deceleration, speed, bending, last driving time, and last driving mileage. ',
      text4:
        'Vehicle Status Data: refers to the real-time status of the Vehicle, including driving mode, residual fuel, instant fuel economy, mileage, real-time gear of the vehicle, engine speed, tire pressure, tire temperature, battery activation voltage data, coolant temperature, electronic lock status, intelligent device software version, signal strength of smart devices, current setting of the dashboard.',
      text5:
        'Vehicle Alarm Data: alarm data to be sent if certain data exceeds a preset value, such as engine temperature, excessive speed, excessive driving time, high coolant temperature, abnormal vehicle movement, abnormal tire pressure, vibration, dumping, collision, etc.',
      text6: 'Vehicle Fault Information: refers to the fault codes reported by each internal part of the Vehicle.',
      text7: 'Vehicle Location Data: refers to the specific geographical whereabouts of the Vehicle.',
      text8: '1.1.	Providing the Customer with vehicle-related services through the CFMOTO RIDE APP.',
      text9: '1.1.1.	The Consumers can remotely manage vehicles through the CFMOTO RIDE APP (including viewing the vehicle location, setting the vehicle information, and functions, remote control of vehicle status, etc.).',
      text10: '1.1.2.	Providing route-planning during navigation, including calculating the distance between vehicles and walking navigation for the purpose of finding a vehicle.',
      text11: '1.2.	Sending necessary notifications to the Customer based on the conditions of the vehicle.',
      text12: '1.2.1.	CFMOTO will send the Customer notifications on vehicle maintenance (e.g. based on the total distance the Customer drive, the time when the Customer buy the vehicle, the time or driving distance requirements for vehicle maintenance).',
      text13: '1.2.2.	Based on vehicle data, CFMOTO will send the Customer abnormal situation notifications; including data analysis by OEM (depending on the model) to provide customer care and follow-up optimization of the vehicle.',
      text14: '1.3.	Support in analyzing the cause of the accident if the Customer reports a serious accident of the Vehicle.',
      text15:
        '1.3.1.	In the event of a serious accident of the Vehicle, such as when the Vehicle overturns or flips over on its side while driving, CFMOTO will support the Customer upon request in clarifying whether the accident is due to a defect in the Vehicle or other circumstances. The request is to be submitted to CFMOTO by the Customer via the local distributor / sales partner indicated in the Vehicle Sales Agreement.',
      text16: '1.3.2.	Insofar as the available data allow this, CFMOTO will evaluate the data in relation to the cause of the accident and provide the Customer with a corresponding report.',
      text17: '1.4.	Assistance for the Customer to recover the Vehicle after the Vehicle is lost.',
      text18: '1.4.1.	If the Vehicle is lost, CFMOTO will provide the Customer with location data of the Vehicle and other useful status data of the Vehicle (such as location of last activation, current vehicle status, etc.) upon request and if available.',
      text19: '1.4.2.	The request is to be submitted to CFMOTO by the Customer via the local distributor / sales partner indicated in the Vehicle Sales Agreement.',
      text20: '1.5.	Reporting of after-sales problems.',
      text21: '1.5.1.	CFMOTO collects remotely error code notifications sent by the Vehicle in case of malfunction of its components and provides respective information upon Customer’s request directly to the Customer.',
      text22: '1.5.2.	The request is to be submitted to CFMOTO by the Customer via the local distributor / sales partner indicated in the Vehicle Sales Agreement.',
      text23: '2.	Restrictions and Exclusions of Service',
      text24: '2.1.	It is expressly pointed out that structural or other technical changes to the Vehicle can limit the provision of the services or even make it impossible, since the services depend on the correct provision of the vehicle data.',
      text25: '2.2.	Where such the services cannot be provided due to the performance of any 3rd party data or telecommunication networks, any liability of CFMOTO is excluded. ',
      text26: '3.	Privacy',
      text27: `CFMOTO will comply with the applicable data protection regulations when processing personal data in connection with the CFMOTO vehicle. The terms of CFMOTO's privacy policy is set out in this CFMOTO RIDE APP. As a supplement to the privacy policy, this notice complies with the privacy policy. And the Customer can refer to the privacy policy for some data-processing related contents not covered by this notice.`,
      text28: '4.	Customer Service',
      text29:
        '4.1.	The Customer can feel free to send privacy-related questions, comments or concerns to CFMOTORIDEAPP@cfmotousa.com or write to: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, MN 55447. The Customer may also call CFMOTO Customer Relations at (888) 823-6686. ',
      text30: '5.	Revisions',
      text31: '5.1.	CFMOTO reserves the right to change this notice at any time, but we will publish revisions on CFMOTO RIDE App and/or provide notice before we do so as appropriate.',
    },
    atmosphere: {
      desTitle: '功能说明',
      setINfo: 'The new settings will take effect within 1-3 minutes after the vehicle is powered on, please make sure the vehicle is in a good signal position',
      setSuccess: 'Set successfully',
      sure: 'Sure',
      confirm: 'Confirm',
      cancel: 'Cancel',
      cContent: 'The settings have not been saved yet, do you want to save them?',
      save: 'Save settings',
      introduce1: 'Near auto unlock instructions',
      introduce2: 'auto power off instructions',
      introduce3: 'Auto wake up instructions',
      introduce4: 'Delayed lights off',
      content1: {
        msg1: 'After the function is turned on, the mobile phone turns on the Bluetooth and the APP keeps running. When approaching the vehicle from far to near, the vehicle can be automatically unlocked and powered on.',
        msg2: 'If it is not normally unlocked and powered on, press the vehicle power button to unlock and power on',
        msg3: 'Proximity auto unlock will only be triggered once before bluetooth is disconnected',
      },
      content2: {
        msg1: 'After the function is turned on, the vehicle will automatically power off after 5 seconds after the three conditions of the vehicle being turned off, the vehicle speed is 0 and the temple is dropped',
        msg2: 'Starting the vehicle during the automatic power-off period, the vehicle speed is not 0, or the temple is put away will cancel the automatic power-off',
      },
      content3: {
        msg1: 'After the function is turned on, when the vehicle is powered off, the mobile phone turns on the Bluetooth and the APP keeps running or carries the physical key. When approaching the vehicle from far to near, the vehicle lights will flash to welcome guests',
        msg2: 'In order to prevent frequent triggers from causing vehicle power loss, after the welcome function is triggered twice within 30 seconds, it will not resume until 30 minutes later',
      },
      content4: {
        msg1: 'After the function is turned on, the far and low beam lights will be turned on automatically for 10 seconds after the vehicle is powered off',
      },
    },
    ebook: {
      language: 'language',
      placeholder: 'Please input the frame number',
      search: 'Search',
      switch: 'Change Language',
      choice: 'Language Choice',
      check: 'More',
      adaptable: 'Fitts For',
      updateTime: 'Update Time',
      empty: 'No instruction',
      title: 'ebook',
    },
    feedback: {
      label: {
        type: 'Feedback',
        content: 'Detailed description',
        fileList: 'Please upload pictures(<5) or a video, picture size< 5MB, video size < 50MB',
        fileList2: '(Maximum 4 pictures / 1 video)',
        feedbackCreate: 'Click to feedback',
        feedbackSupplement: 'Additional Feedback',
        backHome: 'Back to home page',
        vehicle: 'associated vehicle',
        selectVehicle: 'select vehicle',
      },
      placeholder: {
        'content.bug': 'Please describe in detail the time of occurrence, APP version, cell phone model, operation path and problem description to help quickly locate and troubleshoot the problem!',
        'content.suggest': 'Welcome to make valuable suggestions, we will seriously consider your ideas',
        'content.vehicle': 'Please describe when it happened, how it happened and the problem',
        'content.other': 'Please describe when it happened, how it happened and the problem',
        'content.supplement': 'Please add a description of the problem',
        vehicle: 'Please select a vehicle',
      },
      rules: {
        'type.required': 'Please select a feedback type',
        'content.required': 'Please enter a description of your problem',
        'fileList.uploading': 'Uploading, please wait',
        'fileList.maxSize': 'The uploaded file is too large',
        'fileList.overType': 'Unsupported format',
        'fileList.maxCount': 'The number of uploads exceeds the limit',
        'fileList.acceptImageVideo': 'Video cannot be selected when selecting images',
        'vehicle.required': 'Please select a vehicle',
      },
      message: {
        empty: 'There are no feedback records at the moment.',
        finish: 'All in here',
        loading: 'Loading',
        uploadFailed: 'Upload failed',
        tip: 'To protect your account security, please do not upload information that is   unrelated to your issues, for example, your password, personal photos,etc.',
        feedbackSuccess: 'Feedback received',
        'submit.error': 'Feedback failed',
        'submit.success': 'Feedback received',
      },
    },
    guide: {
      label: { giveFeedback: 'Unsolved, need more help' },
    },
    help: {
      label: {
        history: 'Search records',
        cancel: 'Cancel',
        yes: 'Yes',
        no: 'No',
        unresolved: "Still can't solve? Click",
        submitFeedback: 'Submit feedback',
      },
      placeholder: {
        search: 'Search',
        'content.required': 'Please enter keyword',
      },
      message: {
        empty: 'No related content',
        empty2: 'Suggest changing keywords or',
        finish: 'All in here',
        historyDelete: 'Delete all search records?',
        isHelpful: 'Does it help?',
      },
    },
    unbinding: {
      label: {
        vin: 'VIN',
        realName: 'Your full name',
        email: 'Email address',
        phone: 'Phone number',
        areaCode: 'Country code',
        identity: 'Identification',
        drivingLicense: 'Vehicle Registration Certificate',
        backHome: 'Back to home page',
        areaCodeTitle: 'Country code',
        latterTitle: 'Notice',
        agree: 'Approval  ',
        disagree: 'Disagree',
        agreeCheckLabel: 'I have read and agree to',
        agreeCheckTitle: 'Instructions for applying for vehicle unbinding',
      },
      placeholder: {
        vin: 'Please enter the VIN',
        realName: 'Please enter your full name',
        email: 'Please enter your email address',
        phone: 'Please enter your phone number',
        identity: "Main page of ID card, driver's license or passport that contains personal identification information",
        drivingLicense: "VRC main page with owner's name and VIN",
      },
      rules: {
        'agree.required': 'Please read and agree',
        'vin.required': 'Please enter the VIN',
        'vin.pattern': 'Wrong VIN, please check',
        'realName.required': 'Please enter your real name',
        'email.required': 'Please enter your email address',
        'email.pattern': 'Email address format is wrong, please check',
        'phone.required': 'Please enter your phone number',
        'phone.pattern': 'Phone number format error, please check',
        'fileList.maxCount': 'The number of uploads exceeds the limit',
        'fileList.uploading': 'Uploading, please wait',
      },
      message: {
        imgUploadFailed: 'Image upload failed',
        securityMessage: 'The above information is used for identity verification only, CFMOTO safeguards your information',
        resultMessage: 'We will verify the application materials as soon as possible, please pay attention to the notification bar or APP message center in time.',
        loading: 'Loading',
      },
    },
  },
};
